<mat-icon svgIcon="reduce-xs"></mat-icon>
